import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=c141929e&scoped=true&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=c141929e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c141929e",
  null
  
)

export default component.exports